module.exports = __webpack_public_path__ + "img/logo_black.46989b30.png";